<ul>
    <ng-container *ngTemplateOutlet="Recursion; context: { list: data }"></ng-container>
</ul>

<ng-template #Recursion let-list="list">
    <ng-container *ngFor="let item of list">
        <div class="mb-4">
            <div class="flex justify-between items-center">
                <mat-checkbox
                    class="filter-checkbox"
                    [disabled]="item.disabled"
                    [checked]="item.selected"
                    [value]="item.id"
                    (change)="onFilterChange(item, $event)">
                    <div class="font-medium">{{ item.name | translate }}</div>
                </mat-checkbox>

                <button
                    *ngIf="item.children && item.children.length > 0"
                    type="button"
                    class="flex items-center transition-all duration-200"
                    [ngClass]="item.expanded ? 'rotate-180' : ''"
                    (click)="toggleExpand(item)">
                    <mat-icon>{{ 'expand_more' }}</mat-icon>
                </button>
            </div>

            <ng-container *ngIf="item.expanded">
                <div class="ml-4 mt-4">
                    <ng-container *ngTemplateOutlet="Recursion; context: { list: item.children }"></ng-container>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>
